import { createContext, useContext } from 'react';

export type AdminAuthStatus = 'authenticated' | 'unauthenticated';

export interface AdminAuthContextValue {
  status: AdminAuthStatus;
  // PARA-151 (AR-10): id текущего админа — нужен, чтобы на экране "Admins"
  // отличать свою строку (Enable/Disable MFA) от чужих (Reset MFA).
  adminId: number | null;
  login: (token: string, adminId: number) => void;
  logout: () => void;
}

// Отдельный React Context, полностью независимый от AuthContext frontend/
// (разные приложения, разные origin/порты) — см. story §4 UI-архитектуры.
export const AdminAuthContext = createContext<AdminAuthContextValue | null>(null);

export function useAdminAuth(): AdminAuthContextValue {
  const context = useContext(AdminAuthContext);
  if (context === null) {
    throw new Error('useAdminAuth must be used within AdminAuthProvider');
  }
  return context;
}
